export default __webpack_public_path__ + "static/media/background_ws_512.e15116e2.jpg";